export function openWindowWithPost(url, data, target=null) {
    let form = document.createElement("form")
    form.target = target ? target : "_blank"
    form.method = "POST"
    form.action = url
    form.style.display = "none"

    for (const key in data) {
        let input = document.createElement("input")
        input.type = "hidden"
        input.name = key
        input.value = data[key]
        form.appendChild(input)
    }

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
}

export async function postData(url, data, errorText='') {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }

        return await response.json();
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        if (errorText) {
            console.log(errorText);
        }
        return {};
    }
}

export async function postDataBlob(url, data, errorText='') {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }

        return await response.blob()
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        if (errorText) {
            console.log(errorText);
        }
        return {};
    }
}